import { Controller } from "@hotwired/stimulus"

// The "all events of this day" modal in the month grid: a <dialog> holding a
// Turbo Frame whose src changes with the day that was clicked.
export default class extends Controller {
  static targets = ["dialog", "frame"]

  open(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.url
    this.frameTarget.innerHTML = ""
    this.frameTarget.src = url
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  // Click on the backdrop (outside the box) closes.
  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
